export class Logger {
  constructor(protected context: string) {}

  log(message: unknown) {
    console.log(this.context, message);
  }
  error(message: unknown) {
    console.error(this.context, message);
  }
  warn(message: unknown) {
    console.warn(this.context, message);
  }
  debug(message: unknown) {
    console.log(this.context, message);
  }
  verbose(message: unknown) {
    console.log(this.context, message);
  }
}
